export type LoginFormHandler = (
  e: SubmitEvent & { currentTarget: EventTarget & HTMLFormElement },
) => Promise<{ notifications: string[]; success: boolean }>;

export type TrackingFlag =
  | 'login_form_show'
  | 'signup_form_show'
  | 'reset_pw_form_show'
  | 'login_form_start'
  | 'signup_form_start'
  | 'reset_pw_form_start'
  | 'login_form_submit'
  | 'signup_form_submit'
  | 'reset_pw_form_submit'
  | 'login_form_complete'
  | 'signup_form_complete'
  | 'reset_pw_form_complete';

export function initTrackingFlags<T extends string>(defaultValue: boolean): Record<T, boolean> {
  return Object.fromEntries(
    [
      'login_form_show',
      'signup_form_show',
      'reset_pw_form_show',
      'login_form_start',
      'signup_form_start',
      'reset_pw_form_start',
      'login_form_submit',
      'signup_form_submit',
      'reset_pw_form_submit',
      'login_form_complete',
      'signup_form_complete',
      'reset_pw_form_complete',
    ].map((key) => [key, defaultValue]),
  ) as Record<T, boolean>;
}

export type LoginFormTrackingEvent = {
  event_action: string;
  event_group: string;
  event_variant: string;
  error_type?: string;
  error_message?: string;
};
